import type { Vacancy } from '@/api/schema';
import { RichTextContent } from '@/components/ui/RichTextContent';
import { apiUrl } from '@/lib/env';
import styles from '../pages/CareersPage.module.css';

export function VacancyDetails({
  job,
  publicView = false,
}: {
  job: Vacancy;
  publicView?: boolean;
}) {
  const imageUrl = (id: string) =>
    apiUrl(
      publicView
        ? `/api/v1/public/jobs/${job.id}/images/${id}`
        : `/api/v1/careers/vacancies/${job.id}/images/${id}`,
    );

  return (
    <div className={styles.details}>
      <p className={styles.meta}>{[job.location, job.country].filter(Boolean).join(' · ')}</p>
      <dl className={styles.facts}>
        <div>
          <dt>Industry</dt>
          <dd>{job.industry}</dd>
        </div>
        <div>
          <dt>Employment</dt>
          <dd>{job.employment_type}</dd>
        </div>
        <div>
          <dt>Salary</dt>
          <dd>{job.salary || 'To be discussed'}</dd>
        </div>
      </dl>
      <div>
        <h3>Job description</h3>
        <RichTextContent
          blocks={job.description_blocks}
          fallback={job.description}
          imageUrl={imageUrl}
        />
      </div>
      {job.requirements || job.requirements_blocks?.length ? (
        <div>
          <h3>Experience and requirements</h3>
          <RichTextContent
            blocks={job.requirements_blocks}
            fallback={job.requirements}
            imageUrl={imageUrl}
          />
        </div>
      ) : null}
    </div>
  );
}
